// extracted by mini-css-extract-plugin
export default {"addMenu":"RmfPq","addBtn":"Gq9VA","addBtnActive":"RltG0","blocks":"I0MzU","block":"wv151","blockMenu":"ch_Yn"};